import { defineMessages } from 'react-intl';

export const scope =
  'app.commonUtils.capUiLibrary.CapAskAira.RuleSummarizationBot';

export default defineMessages({
  textToExpression: {
    id: `${scope}.textToExpression`,
    defaultMessage: 'Text to expression',
  },
  expressionToText: {
    id: `${scope}.expressionToText`,
    defaultMessage: 'Expression to text',
  },
  queryAnalysis: {
    id: `${scope}.queryAnalysis`,
    defaultMessage: 'Hang tight, analyzing your query...',
  },
  rulePlaceholder: {
    id: `${scope}.rulePlaceholder`,
    defaultMessage: 'Ask Aira to write an expression',
  },
  expressionPlaceholder: {
    id: `${scope}.expressionPlaceholder`,
    defaultMessage: 'Ask Aira to explain an expression',
  },
  airaTranslation: {
    id: `${scope}.airaTranslation`,
    defaultMessage: 'Aira Expression Translator',
  },
  airaTranslationDescription: {
    id: `${scope}.airaTranslationDescription`,
    defaultMessage:
      'Write your detailed rule in simple English and Aira will write the expression',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'An error occurred while generating rule. Try again.',
  },
  errorMessageSummarize: {
    id: `${scope}.errorMessageSummarize`,
    defaultMessage: 'An error occurred while generating explanation. Try again.',
  },
  summarizeTranslation: {
    id: `${scope}.summarizeTranslation`,
    defaultMessage:
      'Enter the Expression and Aira will generate a summary in plain English',
  },
});
